import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import CartContext from './components/Tienda/components/ParadigmaCartProvider';
import LoginContext from './components/Tienda/components/ParadigmaLoginProvider';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop'

import Tienda from './views/Tienda/Tienda';
import QuienesSomos from './views/QuienesSomos/QuienesSomos';
import EnviaTuCV from './views/EnviaTuCV/EnviaTuCV';
import Contacto from './views/Contacto/Contacto';
import Proveedores from './views/Proveedores/Proveedores';
import Sucursales from './views/Sucursales/Sucursales';
import Profesionales from './views/Profesionales/Profesionales';

import Home from './views/Home/Home';
import WhatsAppChat from './components/WhatsAppChat/WhatsAppChat';

import 'font-awesome/css/font-awesome.min.css';

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop>
          <LoginContext>
            <CartContext>
              <Header />
              <div className="min-heigth-body">
              <Switch>
                <Route path="/contacto/:sucursal" render={(props) => (<Contacto {...props} />)} />
                <Route path="/contacto" render={(props) => (<Contacto {...props} />)} />
                <Route path="/quienessomos" render={(props) => (<QuienesSomos {...props} />)} />
                <Route path="/proveedores" render={(props) => (<Proveedores {...props} />)} />
                <Route path="/profesionales" render={(props) => (<Profesionales {...props} />)} />
                <Route path="/tienda" render={(props) => (<Tienda {...props} />)} />
                <Route path="/enviatucv" render={(props) => (<EnviaTuCV {...props} />)} />
                <Route path="/sucursales" render={(props) => (<Sucursales {...props} />)} />
                <Route path="/" render={(props) => (<Home {...props} />)} />
              </Switch>
              </div>
              <Footer />
            </CartContext>
          </LoginContext>
        </ScrollToTop>
      </Router>
      <WhatsAppChat />
    </div>
  );
}

export default App;
